import React from 'react';
import { useCssHandles } from '../../utils/functions';

const CSS_HANDLES = [
	'collapsibleContent',
	'submenuItem',
	'styledLinkContainer',
	'styledLink',
	'styledLinkContent',
	'styledLinkText',
	'seeAllLinkContainer',
	'seeAllLink',
];
const ThirdLevel = ({ blockClass, items, secondLevelIsOpen }) => {
	const { handles } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass);
	const getStyles = () => {
		return secondLevelIsOpen
			? { height: 'auto', overflow: 'hidden', transition: 'height 250ms ease-in-out 0s' }
			: { height: '0px', overflow: 'hidden', transition: 'height 250ms ease-in-out 0s' };
	};
	return (
		<div role="region" style={getStyles()}>
			<div className={`${handles.collapsibleContent}`}>
				{items?.map(({ name }) => (
					<div className={`${handles.submenuItem} mt3`}>
						<div className={`${handles.styledLinkContainer}`}>
							<a className={`${handles.styledLink} no-underline c-on-base w-100 pa0 t-body pointer`} href="#">
								<div className={`${handles.styledLinkContent} flex justify-between`}>
									<div className={`${handles.styledLinkText} flex justify-between items-center`}>{name}</div>
								</div>
							</a>
						</div>
					</div>
				))}
			</div>
			<div className={`${handles.seeAllLinkContainer} mt4 mb6 t-body`}>
				<a href="#" className={`${handles.seeAllLink} link underline fw7 c-on-base`}>
					Ver tudo
				</a>
			</div>
		</div>
	);
};

export default ThirdLevel;
